import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { createStyles, rem } from '@mantine/core'

interface StylesParams {
  hasSlider?: boolean
}

export default createStyles((theme, { hasSlider }: StylesParams) => {
  return {
    root: {
      position: 'relative',
      backgroundImage:
        'linear-gradient(162.45deg, #DDF0FF 2.18%, #80BDFF 99.05%)',
      [theme.fn.smallerThan('sm')]: { padding: `${rem(24)} 0` },
      [theme.fn.largerThan('sm')]: {
        '&:before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${CommonGAssets.getAssetPath(
            'tiki/circle-patter.png',
          )})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        },
      },
    },
    container: {},
    heading: {},
    body: {
      display: 'flex',
      alignItems: 'center',
      ...(!hasSlider && {
        justifyContent: 'center',
      }),
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
      [theme.fn.largerThan('sm')]: {
        gap: hasSlider ? 24 : 80,
      },
    },
    listing: {
      position: 'relative',
      ...(hasSlider && {
        width: '100%',
      }),
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
      },
      '.arrow': {
        width: 40,
        height: 40,
      },
      '.arrow-next': {
        right: -60,
      },
      '.arrow-prev': {
        left: -60,
      },
    },
    thumbnail: {
      position: 'relative',
      [theme.fn.largerThan('sm')]: {
        width: 456,
        minHeight: 585,
        flexShrink: 0,
      },
    },
    item: {
      display: 'block',
      transition: 'all .3s ease',
      '&, & *': {
        borderRadius: 8,
      },
      [theme.fn.largerThan('sm')]: {
        ...(!hasSlider && {
          width: 240,
        }),
        '&:hover': {
          '.item-title': {
            transform: 'translateY(-10px)',
          },
          '.item-overlay-wrapper': {
            backgroundColor: 'rgba(0,0,0,0.4)',
          },
        },
      },
    },
    itemThumbImg: {},
    itemThumb: {},
    overlayWrapper: { transition: 'all .3s ease' },
    overlay: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      right: 0,
      backgroundImage:
        'linear-gradient(180deg, rgba(17, 17, 17, 0) 0%, #111111 100%)',
      minHeight: 96,
      padding: '16px 12px',
      display: 'flex',
      alignItems: 'flex-end',
    },
    title: {
      transition: 'all .3s ease',
    },
  }
})
